// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__28TSZ","logo":"styles_logo__OEtnX","title":"styles_title__1K7lc","large":"styles_large__1iFYz"};